import React, { Fragment } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { actualizarUsuarioAtencionACliente, agregarUsuarioAtencionACliente, reasignacionDeCartera, verificarUsuario } from '../../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'
import { useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import estilos from './GenerarUsuariosComponent.module.css'
import { DataGrid } from '@mui/x-data-grid';
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import moment from 'moment'
import { useSelector } from 'react-redux'
import { agregarHistorialCartera } from '../../../../redux/DucksAtencionACliente/HistorialAtencionAClienteDucks'


const GenerarUsuariosComponent = (props) => {
    const dispatch = useDispatch()
    let fechaHoy = new Date(moment().format('YYYY-MM-DD'))
    const dataUser = useSelector(store => store.Usuario.user)

    const usuarioModify = props?.usuarioModify

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const [initialStateFormik, setInitialStateFormik] = React.useState({
        id: '',
        nombre: '',
        apellidos: '',
        telefono: '',
        usuario: '',
        password: '',
        puesto: 'Auxiliar Nacional',
        estatus: '',
    })
    React.useState(() => {
        if (usuarioModify != null) {
            setInitialStateFormik({
                id: usuarioModify?.id,

                usuario: usuarioModify?.usuario,
                password: usuarioModify?.password,
                puesto: usuarioModify?.puesto,
            })
        }
    }, [props?.usuarioModify])

    const agregarUsuario = async (values) => {
        const usuario = {
            id: uuidv4(),
            //nombre: values.nombre,
            //apellidos: values.apellidos,
            //telefono: values.telefono,
            usuario: values.usuario,
            password: values.password,
            puesto: values.puesto,
        }
        props.functionAcept(usuario)

    }
    const verificarUser = async (usuario) => {
        const user = await dispatch(verificarUsuario(usuario))
        return user.payload
    }
    const actualizarUsuario = async (values, usuarioModify) => {

        let usuario = {
            id: values.id,
            usuario: values.usuario,
            puesto: values.puesto,
        }
        if (usuarioModify.password !== values.password) {
            usuario.password = values.password
        }
        props.functionActualizar(usuario)
    }
    const validarInputs = async (values) => {
        const errors = {};
        const textError = 'Campo obligatorio'
        /*if (!values.nombre) { errors.nombre = textError }
        if (!values.apellidos) { errors.apellidos = textError }
        if (!values.telefono) { errors.telefono = textError }
        else if ((values.telefono + '').length !== 10) { errors.telefono = 'Debe contener 10 digitos' }*/
        if (!values.usuario) { errors.usuario = textError }
        else {
            //let valido = validarEmail(values.usuario)
            //if (!values.usuario) errors.usuario = 'Verifica la estructura de tu correo electrónico'
            //else {
            if (usuarioModify) {
                if (values.usuario !== usuarioModify.usuario) {
                    const correoValidado = await verificarUser(values.usuario)
                    if (correoValidado) errors.usuario = 'El correo electrónico ya se encuentra registrado'
                }
            } else {
                const correoValidado = await verificarUser(values.usuario)
                if (correoValidado) errors.usuario = 'El correo electrónico ya se encuentra registrado'
            }
            //}
        }
        if (!values.password) { errors.password = textError }
        if (!values.puesto) { errors.puesto = textError }
        else if (values.puesto === 'default') { errors.puesto = textError }
        if (values.puesto === 'Ejecutivo' && !values.cartera) { errors.cartera = textError }

        return errors
    }
    return (
        <Fragment>
            <div className='row justify-content-center'>
                <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 `}>
                    <h3 className={`${estilos.tituloForm}`}>{
                        usuarioModify ?
                            "EDITAR USUARIO AUXILIAR NACIONAL" :
                            "REGISTRAR USUARIO AUXILIAR NACIONAL"
                    }</h3>
                    <Formik initialValues={initialStateFormik}
                        validate={async values => {
                            const errors = await validarInputs(values)
                            return errors;
                        }}
                        onSubmit={async (values, { setSubmitting }) => {
                            if (usuarioModify) {
                                await actualizarUsuario(values, usuarioModify)
                            } else {
                                await agregarUsuario(values)
                            }
                            setSubmitting(false);
                        }} >
                        {({ isSubmitting, values }) => (
                            <Form>
                                <div className={`row mt-3 mb-3 ${estilos.contenedorForm}`}>
                                    <div className='col-md-12 mt-0'>
                                        <label htmlFor="puesto">Puesto:</label><br />
                                        <Field as="select" name="puesto" className='form-control'>
                                            {/*<option key='0'>Seleccione una opción</option>*/}
                                            <option value='Auxiliar Nacional'>Auxiliar Nacional</option>
                                        </Field>
                                        <ErrorMessage name="puesto" component="div" className={`${estilos.error}`} /><br />
                                    </div>
                                    <div className='col-md-6 mt-3'>
                                        <label>Usuario:</label><br />
                                        <Field type="text" name="usuario" className='form-control'></Field>
                                        <ErrorMessage name="usuario" component="div" className={`${estilos.error}`} /><br />
                                    </div>
                                    <div className='col-md-6 mt-3'>
                                        <label>Contraseña:</label><br />
                                        <Field type="password" name="password" className='form-control'></Field>
                                        <ErrorMessage name="password" component="div" className={`${estilos.error}`} /><br />
                                    </div>
                                    <div className="col-12 mt-4 text-center">
                                        <button type="submit" disabled={isSubmitting} className='btn btn-success' style={{ fontFamily: 'Montserrat', width: '50%' }}>
                                            { usuarioModify ? "Guardar cambios" : "Registrar nuevo usuario" }
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(GenerarUsuariosComponent)